module.exports = new __parcel__URL__("blank.322437c4.png").toString();